import { getFormattedLongDate } from '@utilities';

/** Returns whether a message is a conversational assistant response. */
export const isAssistantResponseMessage = (message) =>
  message?.role === 'assistant' &&
  message?.type !== 'run_flow' &&
  message?.type !== 'run_flow_created';

/** Formats a Narrative timestamp for display, or returns null when invalid. */
export const formatNarrativeDate = (createdAt) => {
  if (typeof createdAt !== 'string' || !createdAt.trim()) return null;

  const date = new Date(createdAt);
  return Number.isNaN(date.getTime()) ? null : getFormattedLongDate(date);
};

/** Adds optimistic Narrative cards that are not already in the chat history. */
export const mergeOptimisticNarratives = (messages, optimisticNarratives) => {
  if (!Array.isArray(optimisticNarratives) || optimisticNarratives.length === 0) {
    return messages;
  }

  const existingFlowIds = new Set(
    messages
      .filter((message) => message?.type === 'run_flow')
      .map((message) => String(message?.narrative?.flowId))
  );
  const nextMessages = [...messages];
  let didAddNarrative = false;

  optimisticNarratives.forEach((narrative) => {
    const flowId = narrative?.flowId;
    if (flowId == null || existingFlowIds.has(String(flowId))) return;

    nextMessages.push({
      id: `run-flow-${flowId}`,
      narrative,
      role: 'assistant',
      type: 'run_flow',
    });
    didAddNarrative = true;
    existingFlowIds.add(String(flowId));
  });

  return didAddNarrative ? nextMessages : messages;
};
